/** A subset of Price from cart */

/** A subset of Course API for prices */

/**
 * Convert Course API price fields to props suitable for `StaticPriceText` or
 * `DynamicPriceText`.
 *
 * @param course - Course API course object
 * @returns props for `StaticPriceText` or `DynamicPriceText`
 */
export const coursePriceToText = ({
  discount,
  price_detail: priceDetail
}) => {
  // Assert arguments to parseFloat as strings, even though they'll be numbers.
  // parseFloat will coerce numbers into strings before parsing:
  // see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/parseFloat
  const listPrice = priceDetail ? parseFloat(priceDetail.amount) : 0;
  const listPriceString = priceDetail ? priceDetail.price_string : undefined;
  const discountPrice = discount ? parseFloat(discount.price.amount) : listPrice;
  const discountPriceString = discount ? discount.price.price_string : listPriceString;
  return {
    discountPrice,
    discountPriceString,
    listPrice,
    listPriceString
  };
};
//# sourceMappingURL=course-price-to-text.js.map